import { useEffect, useState } from "react";
import { motion } from 'framer-motion';
import Slider from "react-slick";
import { fetchTestimonials } from "../services/reviewHandler";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function TestimonialSlider() {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const loadTestimonials = async () => {
      try {
        const fetchedTestimonials = await fetchTestimonials();
        setTestimonials(fetchedTestimonials);
      } catch (error) {
        console.error("Error loading testimonials:", error);
      }
    };

    loadTestimonials();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3, 
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024, 
        settings: {
          slidesToShow: 1, 
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="bg-gradient-to-b from-custom-4 to-custom-6 py-12 sm:py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-xl text-center">
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Hear from Our Participants
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mx-0 lg:max-w-none">
          <Slider {...settings}>
            {testimonials.map((testimonial, index) => (
              <div key={index} className="px-4">
                <div className="rounded-2xl bg-white p-8 text-gray-700">
                  <blockquote className="h-32 overflow-hidden text-base italic leading-relaxed">
                    <p>“{testimonial.body}”</p>
                  </blockquote>
                  <figcaption className="mt-6 text-right">
                    <div className="font-semibold text-gray-900">
                      {testimonial.name}
                    </div>
                  </figcaption>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}
